import {Component, OnInit, ViewChild} from '@angular/core';
import {NavService} from '../../../_services/_nav.service';
import {RxStompService} from '@stomp/ng2-stompjs';
import {Router} from '@angular/router';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {Funcionalidad} from '../../../_models/funcionalidad';
import {ConstanteService} from '../../../_services/constante.service';

import {Pagaduria} from '../../../_models/pagaduria';
import {SelectItem} from 'primeng/api';
import {ListaService} from '../../../_services/lista.service';
import {forkJoin} from 'rxjs';
import {Table} from 'primeng/table';
import {PagaduriaService} from '../../../_services/pagaduria.service';
import {CodigosEstadosFuncionalidades, ControlesPagaduria} from '../../../_enums/enum';
import {BusquedaFiltros} from '../../../_models/busqueda-filtros';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FuncionalidadesService} from '../../../_services/funcionalidades.service';
import {RolFuncionalitiesServices} from '../../../_services/rol-funcionalidad.service';

@Component({
  selector: 'app-pagaduria-listado',
  templateUrl: './pagaduria-listado.component.html',
})
export class PagaduriaListadoComponent implements OnInit {

  cargando = false;
  formulario: FormGroup;
  busqueda: string;
  cEstadoFuncionalidad = CodigosEstadosFuncionalidades;
  buscando = false;
  pagina: string;
  regPorPagina = 10;
  submitted = false;
  contanteRDUCON: any;
  numRegistros: number;
  contanteRDUAPR: any;
  permiso = false;
  verAgregar: any;
  cargandoTabla = true;
  @ViewChild("dt", { static: true }) tabla: Table;
  pagaduria: Pagaduria;
  rolesUsuarioLogueado: any;
  idEstadoFuncionalidad: number;
  lisEstadosTiposFuncionalidades: SelectItem[] = [];
  pagaduriasListado: Pagaduria[] = [];
  mostrarActivarTarea: boolean;
  funcionalidad: Funcionalidad = new Funcionalidad();
  verAprobacionCondicion = false;
  columnas: any[] = [];

  constructor( private navService: NavService,
               private router: Router,
               private fb: FormBuilder,
               private lisServicio: ListaService,
               private rxStompService: RxStompService,
               private pagaduriaService: PagaduriaService,
               private funService: FuncionalidadesService,
               private autenticacionService: AutenticacionService,
               private conConstanteServicio: ConstanteService,
               private rolFuncionalControlService: RolFuncionalitiesServices,
  ) { }

  async ngOnInit() {
    this.cargarFormulario();
    this.funcionalidad  = this.autenticacionService.obtenerFuncionalidades().find( x => x.ruta === 'apl/pagaduria' );
    this.busqueda = this.navService.getSearch('pagaduria-listado.component');
    this.cargartabla();
    forkJoin(
     this.conConstanteServicio.getByCode('RDUCON'),
     this.conConstanteServicio.getByCode('RDUAPR'),
     this.lisServicio.getMasterDetails( 'ListasEstadosFuncionalidades' ),
     this.rolFuncionalControlService.getSeccionesByCodigoFuncionalidad('PAGADU', this.autenticacionService.obtenerIdUsuarioLogueado())
    ).subscribe( ( [constanteRDUCON, constanteRDUAPR, lisEstadosFuncionalidades, rolesFuncionalidad] ) => {
              lisEstadosFuncionalidades.forEach( s => {
                  if (CodigosEstadosFuncionalidades.PENDIENTE !== s.codigo &&
                      CodigosEstadosFuncionalidades.APROBADO !== s.codigo &&
                      CodigosEstadosFuncionalidades.DENEGADO !== s.codigo) {
                      this.lisEstadosTiposFuncionalidades.push({label: s.nombre, value: s.idLista});
        }
      });
              const l = lisEstadosFuncionalidades.find(x => x.codigo === this.cEstadoFuncionalidad.ACTIVO);
              this.f.estadoFuncionalidad.setValue([l.idLista]);
              this.contanteRDUCON = constanteRDUCON;
              this.contanteRDUAPR = constanteRDUAPR;
              this.buscar();
              this.rolesUsuarioLogueado = this.autenticacionService.obtenerRolesUsuarios(),
              this.validarRolesConfigurados(rolesFuncionalidad);
    });
  }
  // FUNCIONES

  async lanzarTarea(row: any) {
    const tareaProgramada = await this.pagaduriaService.enviarTareaProgramada(row.idPagaduria).toPromise();
    if (tareaProgramada && !tareaProgramada.estado && tareaProgramada.codigoMensaje) {
      this.navService.setMesage(0, {
        severity: 'info',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: tareaProgramada.codigoMensaje,
      });
    } else if (tareaProgramada && tareaProgramada.estado) {
      this.navService.setMesage(0, {
        severity: 'success',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('PAGADURIA.LBL_CONDICIONAPROBADO'),
      });
    }
  }

  editar(row: any) {
    this.router.navigate(['apl/pagaduria/editar/' + row.idPagaduria]);
  }

  agregar() {
    this.router.navigate(['apl/pagaduria/agregar']);
  }

  buscar(event?: any) {
    this.buscarPorFiltros(event);
  }

  verPagaduria(row: any) {
    this.router.navigate(['apl/pagaduria/detalle/' + row.idPagaduria]);
  }

  cargartabla() {
    this.columnas = [
      { field: 'codigo', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_CODIGO' ), sort: false },
      { field: 'pagaduria', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_PAGADURIA' ), sort: false },
      { field: 'nit', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_NIT' ), sort: false },
      { field: 'diaCorte', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_DIACORTE' ), sort: false },
      { field: 'diaPago', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_DIAPAGO' ), sort: false },
      { field: 'metodo', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_METODO' ), sort: false },
      { field: 'desfaseAntes', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_DESFASEANTES' ), sort: false },
      { field: 'desfaseDespues', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_DESFASEDESPUES' ), sort: false },
      { field: 'aprobacionPagaduria', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_APROBACIONPAGADURIA' ), sort: false },
      { field: 'entidad', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_ENTIDAD' ), sort: false },
      { field: 'estado', header: this.navService.buscarMensaje( 'PAGADURIA.LBL_ESTADO' ), sort: false },
      { field: 'acciones', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false },
    ];
    this.cargandoTabla = false;
    this.cargando = false;
  }



  cargarFormulario() {
    this.formulario = this.fb.group({
      estadoFuncionalidad: [null] ,
      buscar: [null] ,
    });
  }

  get f() {
    return this.formulario.controls;
  }

  buscarPorFiltros(event?: any) {
    const formulario = this.formulario.getRawValue();
    this.submitted = true;
    this.cargandoTabla = true;
    this.buscando = true;
    if ( event ) {
      this.pagina = String( event.first / this.regPorPagina );
    } else {
      this.pagina = '0';
      this.tabla.first = 0;
    }

    const a = new BusquedaFiltros();
    a.pagina = Number(this.pagina);
    a.cantidad = this.regPorPagina;
    a.idsEstados = this.f.estadoFuncionalidad.value ? this.f.estadoFuncionalidad.value : null;
    a.search = this.f.buscar.value ? this.f.buscar.value : null;

      this.navService.setFilters('pagaduria-listado', 'search', formulario.buscar);
      this.navService.setFilters('pagaduria-listado', 'estadoFuncionalidad', formulario.estadoFuncionalidad);

    this.pagaduriaService.filter(a).subscribe(filter => {
      this.numRegistros = Number( filter.total );
      this.pagaduriasListado = filter.data;
      this.cargandoTabla = false;
      this.submitted = false;
    }, e => {
      this.cargandoTabla = false;
      this.submitted = false;
      this.mensaje('error', 'LBL_ERROR', 'MSG_ERRORCARGAR');
    });
  }

  mensaje(severity: string, summary: string, detail: string) {
    this.navService.setMesage( 0,
      {
        severity: severity,
        summary: this.navService.buscarMensaje( summary ),
        detail: this.navService.buscarMensaje( detail )
      } );
  }

  validarRolesConfigurados(rolesFuncionalidad: any[]) {
    if (
      !this.contanteRDUCON ||
      !this.contanteRDUAPR ||
      !this.rolesUsuarioLogueado ||
      !this.funcionalidad.editar
    ) {
      console.log('falta configuracion');
      return;
    }
    const listRoles = this.contanteRDUCON.valor.split(',');
    const listRolesDos = this.contanteRDUAPR.valor.split(',');

    if (
      (this.rolesUsuarioLogueado.find(
          (x: any) => x === listRoles.find((y: any) => y === x)
        ) &&
        this.rolesUsuarioLogueado.find(
          (x: any) => x === listRolesDos.find((y: any) => y === x)
        )) ||
      (!this.rolesUsuarioLogueado.find(
          (x: any) => x === listRoles.find((y: any) => y === x)
        ) &&
        !this.rolesUsuarioLogueado.find(
          (x: any) => x === listRolesDos.find((y: any) => y === x)
        ))
    ) {
      this.navService.setMesage(0, {
        severity: 'info',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('PAGADURIA.LBL_NOROLCONFIGURADO'),
      });
      return;
    }
    this.verAgregar = this.rolesUsuarioLogueado.find((x: any) => x === listRoles.find((y: any) => y === x)) ? true : false;

    this.verAprobacionCondicion = this.rolesUsuarioLogueado.find((x: any) => x === listRolesDos.find((y: any) => y === x)) ? true: false;

    this.mostrarActivarTarea = rolesFuncionalidad.length > 0 ? true : false;
  }

}
